'use strict';

angular.module('atex.dam').factory('DamFileService', ['FileService', '$q', '$sce', 'Application', 'PolopolyFSFileService', 'TypeService',
function(FileService, $q, $sce, Application, PolopolyFSFileService, TypeService) {
  
    var getFileAsBlob = function(fileServiceUri) {
      return FileService.getFileAsBlob({ uri: fileServiceUri }).whenCompleted().then(function(response) {
        return response.data;
      });
    };

    var createUrlToBlob = function(blob) {
      var deferred = $q.defer(),
          urlFactory = window.URL || window.webkitURL;

      if (typeof urlFactory !== 'undefined' && typeof urlFactory.createObjectURL !== 'undefined') {
        deferred.resolve(urlFactory.createObjectURL(blob));
      } else {
        var reader = new FileReader();

        reader.onloadend = function() {
          deferred.resolve(reader.result);
        };

        reader.readAsDataURL(blob);
      }

      return deferred.promise;
    };
    
    var getDimensionsForImage = function(imageUrl) {
      var loaderImage = new Image();
      var deferred = $q.defer();

      $(loaderImage).on('load', function() {
        deferred.resolve({
          width: this.width,
          height: this.height
        });
      });

      loaderImage.src = $sce.trustAsResourceUrl(imageUrl);

      return deferred.promise;
    };
    
    var getFileAsUrl = function(fileServiceUri) {
      return getFileAsBlob(fileServiceUri).then(function(imageAsBlob) {
        return createUrlToBlob(imageAsBlob);
      }).then(function(imageUrl) {
        return $sce.trustAsResourceUrl(imageUrl);
      });
    };

    var prepareImageData = function(file, secParentId) {
      return $q.when().then(function() {
        var currentUserId = Application.currentUser.userId;
        var uploadURI = atex.onecms.FileServiceUtils.makeTmpSpaceUri(currentUserId, file.name);
        var fileSize = file.size;
        var upload = FileService.putFile({ data: file, uri: uploadURI });

        return upload.whenCompleted().then(function(uploadInfo) {

          var article = atex.Content();
          article.data.aspects['p.InsertionInfo'] = {
            data : {
              _type : 'p.InsertionInfo',
              securityParentId : secParentId
            }
          };
          article.data.aspects['atex.Metadata'] = {
            data : {
              _type : 'atex.Metadata',
              taxonomyIds : ['p.StandardCategorization'],
              metadata: {
                _type: "com.polopoly.metadata.Metadata",
                dimensions:[]
              }
            }      
          };
          article.data.aspects['contentData'] = {
            data : {
              _type : 'atex.onecms.image',
              inputTemplate : 'p.NosqlImage',
              objectType : 'image',
              title : file.name
            }
          };
          
          var resourceTemplate = {
            aspects: {
              'atex.Files': {
              },
              'atex.Image': {
              }
            }
          };
          
          var domainObjectService = atex.onecms.domain.DomainObjectService($q, PolopolyFSFileService);
          var factory = atex.onecms.domain.DomainObjectFactory($q, TypeService, PolopolyFSFileService, domainObjectService);
          
          return $q.when().then(function() {
            return factory.fromData(article.data, resourceTemplate);
          }).then(function(domainObject) {
            var filesDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(domainObject, 'aspects/atex.Files/data');
            filesDomainObject.addFile(file.name, {
              _type: 'com.atex.onecms.content.ContentFileInfo',
              filePath: file.name,
              fileUri: uploadInfo.data.URI
            });
            var imageDomainObject = atex.onecms.DomainObjectUtils.getDomainObjectByPath(domainObject, 'aspects/atex.Image/data');
            imageDomainObject.setFilePath(file.name);
            
            return getFileAsBlob(uploadInfo.data.URI).then(function(imageAsBlob) {
              return createUrlToBlob(imageAsBlob);
            }).then(function(imageUrl) {
              return getDimensionsForImage(imageUrl);
            }).then(function(dimensions) {
              imageDomainObject.setWidth(dimensions.width);
              imageDomainObject.setHeight(dimensions.height);
              return domainObject.pack();
            });
          });
        });
      });
    };
    
    return {
      getFileAsBlob: getFileAsBlob,
      createUrlToBlob: createUrlToBlob,
      getDimensionsForImage: getDimensionsForImage,
      getFileAsUrl: getFileAsUrl,
      prepareImageData: prepareImageData
    };
    
}]);
